import { useEffect } from 'react';
import { usePortalDestination } from '../PortalDestinationContext';
import { usePortalUnread } from '../PortalUnreadContext';

export const useChatReadReceipt = (conversation, markerRef, onRead) => {
  const { api } = usePortalDestination();
  const { refreshAfterRead } = usePortalUnread();
  useEffect(() => {
    if (!conversation?.read_snapshot || !markerRef.current) return undefined;
    let visible = false;
    let active = true;
    let pending = false;
    let acknowledged = false;
    const controller = new AbortController();
    const acknowledge = async () => {
      if (!active || !visible || pending || acknowledged || document.visibilityState !== 'visible'
          || document.querySelector('[role="dialog"][data-state="open"]')) return;
      pending = true;
      try {
        const { data } = await api.post(`/chat/threads/${conversation.thread_id}/read`, conversation.read_snapshot, { signal: controller.signal });
        if (!active) return;
        acknowledged = data.read;
        if (data.read) onRead(conversation.thread_id, data.unread_remaining);
        refreshAfterRead();
      } catch { /* Leave unread intact; a subsequent visible load will retry. */ }
      finally { pending = false; }
    };
    const bottomNav = document.querySelector('[data-testid="portal-mobile-navigation"]');
    const bottomInset = bottomNav?.getBoundingClientRect().height || 0;
    const observer = new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting;
      acknowledge();
    }, { threshold: 1, rootMargin: `0px 0px -${bottomInset}px 0px` });
    observer.observe(markerRef.current);
    document.addEventListener('visibilitychange', acknowledge);
    window.addEventListener('focus', acknowledge);
    return () => {
      active = false;
      controller.abort();
      observer.disconnect();
      document.removeEventListener('visibilitychange', acknowledge);
      window.removeEventListener('focus', acknowledge);
    };
  }, [api, conversation, markerRef, onRead, refreshAfterRead]);
};